export default __webpack_public_path__ + "static/media/misz.528d5e44.png";